import React from 'react';
import PropTypes from 'prop-types';
import { slide as Menu } from 'react-burger-menu';
import AxStagesDrawerContent from 'ax/components/AxStagesDrawer/components/AxStagesDrawerContent';

class AxStagesDrawer extends React.PureComponent {
  static propTypes = {
    progress: PropTypes.number,
    rotation: PropTypes.number,
    stages: PropTypes.array,
    brandLogoUrl: PropTypes.string,
    axPalette: PropTypes.object,
    progressFraction: PropTypes.string,
    isOpen: PropTypes.bool,
    translations: PropTypes.object,
    isMultiStageDrawer: PropTypes.bool,
    subStages: PropTypes.array,
    portalUrl: PropTypes.string,
  };

  static defaultProps = {
    isOpen: false,
  };

  render() {
    const {
      progress,
      rotation,
      stages,
      brandLogoUrl,
      axPalette,
      progressFraction,
      isOpen,
      translations,
      isMultiStageDrawer,
      subStages,
      portalUrl,
    } = this.props;

    return (
      <div className="ax-side-menu">
        <Menu isOpen={isOpen}>
          <AxStagesDrawerContent
            progress={progress}
            rotation={rotation}
            stages={stages}
            brandLogoUrl={brandLogoUrl}
            axPalette={axPalette}
            progressFraction={progressFraction}
            translations={translations}
            isMultiStageDrawer={isMultiStageDrawer}
            subStages={subStages}
            portalUrl={portalUrl}
          />
        </Menu>
      </div>
    );
  }
}

export default AxStagesDrawer;
